<div class="js-sidebar-content">
  <header class="logo d-none d-md-block">
    <img src="assets/img/careem/careemlogo.png" class="logo-icon" alt="careem_logo" />
    <img src="assets/img/careem/logo.png" class="main-logo" alt="logo" />
  </header>
  <ul class="sidebar-nav">
    <li *ngFor="let item of sidebarMenu" [ngClass]="{ hide : (item.hideForCareemUser && isCareemAccount) }">
      <a *ngIf="!item['subMenu']" [routerLink]=" [item['link']] " (click)="activateRoute(item['link'])" tabindex="-1">
        <span class="icon">
          <i class="{{item['icon']}}"></i>
          </span> {{item['name']}}
      </a>
      <a *ngIf="item['subMenu']" class="collapsed" [attr.data-target]="'#'+item.id" data-toggle="collapse" tabindex="-1">
        <span class="icon">
          <i class="{{item['icon']}}"></i>
          </span> {{item['name']}}
        <i *ngIf="item['subMenu']" class="toggle fa fa-angle-down"></i>
      </a>
      <ul id="{{item.id}}" *ngIf="item['subMenu']" class="collapse">

          <li *ngFor="let subMenuItem of item.subMenu" >
            <a [routerLink]=" [subMenuItem['link']] " (click)="activateRoute(subMenuItem['link'])" tabindex="-1">{{subMenuItem.name}}</a>
          </li>

      </ul>
    </li>
  </ul>
</div>